import { Link } from 'react-router-dom';
import { getFeaturedArticles } from '@/mocks/articles';

export default function FeaturedArticles() {
  const featured = getFeaturedArticles();

  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-10">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-2">
              精选推荐
            </h2>
            <p className="text-foreground-600 text-sm">编辑团队精心甄选的优质内容</p>
          </div>
          <Link
            to="/category/yiqu-jingxuan"
            className="hidden sm:inline-flex items-center gap-1 text-primary-600 hover:text-primary-700 text-sm transition-colors cursor-pointer whitespace-nowrap"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {featured.map((article, idx) => (
            <Link
              key={article.id}
              to={`/article/${article.slug}`}
              className="animate-fade-in-up group bg-background-50 rounded-lg overflow-hidden cursor-pointer transition-all duration-300 hover:bg-background-200/50"
              style={{ animationDelay: `${(idx + 1) * 0.15}s` }}
            >
              <div className="flex flex-col sm:flex-row">
                <div className="sm:w-2/5 h-48 sm:h-auto overflow-hidden">
                  <div className="w-full h-full">
                    <img
                      src={article.coverImage}
                      alt={article.title}
                      className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                    />
                  </div>
                </div>
                <div className="sm:w-3/5 p-5 flex flex-col justify-center">
                  <div className="flex items-center gap-3 mb-2">
                    <span className="text-xs bg-accent-100 text-accent-700 px-2 py-0.5 rounded-full whitespace-nowrap">精选</span>
                    <span className="text-xs text-foreground-500">{article.date}</span>
                    <span className="text-xs text-foreground-500">{article.readTime} 分钟阅读</span>
                  </div>
                  <h3 className="font-heading font-semibold text-foreground-900 text-base mb-2 group-hover:text-primary-600 transition-colors line-clamp-2">
                    {article.title}
                  </h3>
                  <p className="text-foreground-600 text-sm leading-relaxed line-clamp-2">
                    {article.excerpt}
                  </p>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="mt-6 text-center sm:hidden">
          <Link
            to="/category/yiqu-jingxuan"
            className="inline-flex items-center gap-1 text-primary-600 text-sm cursor-pointer whitespace-nowrap"
          >
            查看全部精选 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}